const camelToSnake = (s: string): string => s.replace(/[A-Z]/g, (m) => '_' + m.toLowerCase());

/**
 * Ключи объекта (вглубь) — в snake_case. Так интерцептор axios приводит REST-ответы; SSE идёт
 * мимо axios, поэтому события перед разбором пропускают через эту же функцию — разборщик один,
 * на snake_case. Значения не трогаются. Без alias-импортов: её собирают тесты.
 */
export function snakeizeKeys(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(snakeizeKeys);
  }
  if (value !== null && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      out[camelToSnake(k)] = snakeizeKeys(v);
    }
    return out;
  }
  return value;
}
